<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter clear-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xlarge-size-80 mx-auto"
          >
            <h1 class="title text-center">
              Privacy Policy
            </h1>
            <h4 class="title">
                This privacy policy (the "Privacy Policy") is intended to inform you of our policies and practices regarding the collection, use and disclosure of any information you submit to us. This includes "Personal Information," which is information about you that is personally identifiable such as your name, e-mail address, user ID number, delivery and billing addresses and other non-public information that is associated with the foregoing.
            </h4>
          </div>
        </div>
      </div>
    </parallax>
    <div
      id="main-panel"
      class="main main-raised"
    >
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto"
            >
              <h2 class="title">
                User Consent
              </h2>
              <p>
                By accessing or otherwise using the our platform, you agree to the terms and conditions of this Privacy Policy, which is incorporated into and forms a part of our terms of service You expressly consent to the processing of your Personal Information according to this Privacy Policy.
              </p>
              <p>
                Your Personal Information will be processed and stored in Malaysia governed by the <b>Personal Data Protection Act 2010 (&quot;PDPA&quot;)</b>. Your Personal Information will not be used or disclosed for purposes for which you have not given consent or which are not permitted under applicable law.
              </p>
              <h2 class="title">
                Collection of Information
              </h2>
 
              <h3 class="title">Personal Information That You Provide</h3>
              <p>
                In general, we collect Personal Information that you submit to us voluntarily. We also collect information that you submit in the process of creating or editing your account and user profile. 
              </p>
              <h3 class="title">Personal Information from Other Sources</h3>
              <p>
                We may receive Personal Information about you from other sources with which you have expressly consented to.
              </p>

              <h3 class="title">E-Mail Address</h3>
              <p>
                If you send an e-mail to us, or fill in any of our "Contact" forms, we will collect your e-mail address and the full content of your e-mail, including attached files, and other information you provide.
              </p>

              <h3 class="title">Information Collected Via Technology</h3>
              <p>
                As you use our platform, certain information may also be passively collected and stored on our or our service providers’ server logs, including your Internet protocol address, browser type, and operating system.
              </p>

              <h2 class="title">Use and Disclosure of Information</h2>
              <p>
                Except as otherwise stated in this Privacy Policy, we do not sell, trade, rent, or otherwise share for marketing purposes the Personal Information that we collect from third parties, unless you or authorize us to do so.
              </p>
              <p>
                Personal Information collected is to provide you access, to process orders, to improve, better tailor the features, performance, and support of our platform and to offer you additional information, opportunities, promotions and functionality from us.
              </p>
              <p>
                We may share some or all of your Personal Information with our affiliated and group companies that are under a common control, so that they may send daily deal e-mails to you, in which case we will require them to honor this Privacy Policy. 
              </p>
              <p>
                We may disclose your Personal Information if we believe in good faith that such disclosure is necessary to:
              </p>
              <ul>
                <li>comply with relevant laws or to respond to subpoenas or warrants served on us; or</li>
                <li>to protect and defend our rights or property, you, or third parties. </li>
              </ul>

              <p>
                Please note that your personal information may be transferred, stored and processed outside Malaysia.
              </p>

              <h2 class="title">Security</h2>
              <p>
                We will do our best to protect your personal data, we cannot however guarantee the security of your data transmitted to our site; any transmission is at your own risk and you agree not to hold us responsible for any breach of security while accessing the internet that is out of our control. Once we have received your information, we will use strict procedures and security features to try to prevent unauthorised access.
              </p>

              <h2 class="title">Third party Websites</h2>
              <p>
                Our website may contain links to other sites (the "Linked Sites"). We are not responsible for the privacy policies or practices of such other Linked Sites. You agree to waive any claim against us with respect to the Linked Sites.
              </p>

              <h2 class="title">Your Consent and Rights</h2>
              <p>
                You are accorded with rights stipulated in the Personal Data Protection Act 2010 and we will be abide by the provisions in PDPA.
              </p>

              <h2 class="title">Contact and Revisions</h2>
              <p>
                If you have questions or concerns about our Privacy Policy, please <router-link :to="{name: 'contact-us'}">contact us</router-link>
              </p>
              <p>
                This Privacy Policy is subject to occasional revision at our discretion. If you object to any such changes, you must cease using our platform and any further use shall indicate your acknowledgement of such changes and agreement to be bound by the terms and conditions of such changes.
              </p>
              <p>
                <b>Last updated: </b><i>3rd October 2020</i>
              </p>

            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Mixins from "@/plugins/basicMixins";
export default {
    name: "Privacy",
    components: {
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "privacy-page",
    props: {
        image: {
            type: String,
            default: require("@/assets/img/nature-3.jpg")
        }
    },
    data() {
        return {
        };
    },
    mounted() {
        this.leafActive();
        window.addEventListener("resize", this.leafActive);
        document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.leafActive);
        document.removeEventListener("scroll", this.scrollListener);
    },
    methods: {
        leafActive() {
            if (window.innerWidth < 768) {
                this.leafShow = false;
            } else {
                this.leafShow = true;
            }
        }
    }
};
</script>